import { CheckOutlined, FormOutlined } from '@ant-design/icons';
import { Button, Row, Space, Tooltip } from 'antd';
import { PermissionsEnum } from 'app/containers/User/slice/types';
import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import PermissionsWrapper from '../PermissionsWrapper/PermissionsWrapper';
import * as S from './EditableNorm.styles';

interface IProps {
  activeNormInputResourceId: number | null;
  isEditable: boolean;
  resourceId: number;
  norm: number;
  unit?: string;
  recommendedNorm?: number;
  showWarningCircle?: boolean;
  onChange: (updatedNorm: number) => void;
  onClose: () => void;
  onOpen: () => void;
}

const EditableNorm: FC<IProps> = ({
  activeNormInputResourceId,
  resourceId,
  norm,
  isEditable,
  unit,
  recommendedNorm,
  showWarningCircle = false,
  onChange,
  onClose,
  onOpen,
}) => {
  const { t } = useTranslation();

  return (
    <Row justify="space-between" align="middle">
      {activeNormInputResourceId === resourceId ? (
        <Space>
          <S.NormInput
            defaultValue={norm}
            onChange={e => {
              const updatedNorm = Number(e.currentTarget.value);
              if (!isNaN(updatedNorm) && Number(updatedNorm) > 0) {
                onChange(updatedNorm);
              }
            }}
            suffix={
              <Button type="text" onClick={onClose}>
                <CheckOutlined />
              </Button>
            }
          />
        </Space>
      ) : (
        <>
          <Space>
            <span>{`${norm} ${unit ? `${unit}/Ha` : ''}`}</span>

            {isEditable && (
              <PermissionsWrapper
                requiredEditPermissions={[
                  PermissionsEnum.resourceAdministration,
                ]}
              >
                <Button
                  // className="visible-on-row-hover"
                  type="text"
                  onClick={onOpen}
                >
                  <FormOutlined />
                </Button>
              </PermissionsWrapper>
            )}
          </Space>
        </>
      )}
      {Boolean(
        showWarningCircle && (!recommendedNorm || recommendedNorm < norm),
      ) && (
        <Tooltip
          placement="right"
          title={t('Resource.EditableNorm.MoreThanRecommended', {
            defaultValue: 'More than {{recNorm}} {{unit}}/Ha',
            unit,
            recNorm: recommendedNorm,
          })}
        >
          <S.WarningCircle />
        </Tooltip>
      )}
    </Row>
  );
};

export default EditableNorm;
